/**
 * Compares the selected date if earlier or beyond from the date provided
 */
export default ({ value }) => {
  let pass = true;
  pass = validateExpiryDate(value);

  return pass;
};

const validateExpiryDate = (value) => {
  const splittedDate = value.split('/');
  if (splittedDate && value.length >= 5 && splittedDate[0] < 13) {
    const now = new Date();
    const expiryDate = new Date('20' + splittedDate[1], splittedDate[0], 0, 23, 59, 59);
    return expiryDate >= now;
  }
  return false;
};
